import { makePayment } from '../../../actions/booking/makePayment';

async function submit(values, dispatch) {
  console.log('SUBMITTING RESERVATION', values);

  dispatch(
    makePayment(
      values.listId,
      values.title,
      values.hostId,
      values.guestId,
      values.checkIn,
      values.checkOut,
      values.message,
      values.basePrice,
      values.discount,
      values.discountType,
      values.guestServiceFee,
      values.hostServiceFee,
      values.total,
      values.bookingType,
      values.cardId,
      values.guestEmail,
      values.units,
      values.promoCode
    ),
  );
  //dispatch(reset('PaymentForm'));
}

export default submit;



// WEBPACK FOOTER //
// ./src/components/Booking/Payment/submit.js